// src/pages/PEStamp/PEStampReducer.js

const initialState = {
  peStampData: { attachments: [] },
  currentViewTab: "New",
  refreshPEStampComments: true
};

export const PEStampReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_PESTAMP":
      return { ...state, peStampData: action.payload };

    case "SET_PESTAMP_VIEW_TAB":
      return { ...state, currentViewTab: action.payload };

    case "SET_REFRESH_PESTAMP_COMMENTS":
      return { ...state, refreshPEStampComments: action.payload };

    case "RESET_PESTAMP_STATE":
      return initialState;

    default:
      return state;
  }
};

// -------- ACTIONS --------
export const setPEStamp = (data) => ({
  type: "SET_PESTAMP",
  payload: data
});

export const setPEStampViewTab = (tab) => ({
  type: "SET_PESTAMP_VIEW_TAB",
  payload: tab
});

export const setRefreshPEStampComments = (value) => ({
  type: "SET_REFRESH_PESTAMP_COMMENTS",
  payload: value
});

export const resetPEStampState = () => ({
  type: "RESET_PESTAMP_STATE"
});